import { MultiMetricData } from './../types';
export const demoSelectedGraph = [
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2022-06-01',
          currentValue: 9.69,
          currentValueType: 'percentage',
          previousYearValue: 4.78,
          yoyChange: 102.74
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2022-05-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2022-03-01',
          currentValue: 8.87,
          currentValueType: 'percentage',
          previousYearValue: 6.86,
          yoyChange: 29.22
        },
        {
          date: '2022-04-01',
          currentValue: 8.21,
          currentValueType: 'percentage',
          previousYearValue: 6.85,
          yoyChange: 19.85
        },
        {
          date: '2022-05-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2021-12-01',
          currentValue: 8.87,
          currentValueType: 'percentage',
          previousYearValue: 5.48,
          yoyChange: 61.9
        },
        {
          date: '2022-01-01',
          currentValue: 7.75,
          currentValueType: 'percentage',
          previousYearValue: 5.64,
          yoyChange: 37.41
        },
        {
          date: '2022-02-01',
          currentValue: 5.58,
          currentValueType: 'percentage',
          previousYearValue: 4.44,
          yoyChange: 25.54
        },
        {
          date: '2022-03-01',
          currentValue: 6.29,
          currentValueType: 'percentage',
          previousYearValue: 4.5,
          yoyChange: 39.71
        },
        {
          date: '2022-04-01',
          currentValue: 5.91,
          currentValueType: 'percentage',
          previousYearValue: 4.45,
          yoyChange: 32.78
        },
        {
          date: '2022-05-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2021-06-01',
          currentValue: 4.78,
          currentValueType: 'percentage',
          previousYearValue: 3.31,
          yoyChange: 44.2
        },
        {
          date: '2021-07-01',
          currentValue: 6.62,
          currentValueType: 'percentage',
          previousYearValue: 4.5,
          yoyChange: 47.19
        },
        {
          date: '2021-08-01',
          currentValue: 6.56,
          currentValueType: 'percentage',
          previousYearValue: 3.47,
          yoyChange: 88.98
        },
        {
          date: '2021-09-01',
          currentValue: 5.96,
          currentValueType: 'percentage',
          previousYearValue: 5.24,
          yoyChange: 13.67
        },
        {
          date: '2021-10-01',
          currentValue: 5.28,
          currentValueType: 'percentage',
          previousYearValue: 4.36,
          yoyChange: 13.89
        },
        {
          date: '2021-11-01',
          currentValue: 6.42,
          currentValueType: 'percentage',
          previousYearValue: 4.52,
          yoyChange: 42.15
        },
        {
          date: '2021-12-01',
          currentValue: 8.87,
          currentValueType: 'percentage',
          previousYearValue: 5.48,
          yoyChange: 61.9
        },
        {
          date: '2022-01-01',
          currentValue: 7.75,
          currentValueType: 'percentage',
          previousYearValue: 5.64,
          yoyChange: 37.41
        },
        {
          date: '2022-02-01',
          currentValue: 5.58,
          currentValueType: 'percentage',
          previousYearValue: 4.44,
          yoyChange: 25.54
        },
        {
          date: '2022-03-01',
          currentValue: 6.29,
          currentValueType: 'percentage',
          previousYearValue: 4.5,
          yoyChange: 39.71
        },
        {
          date: '2022-04-01',
          currentValue: 5.91,
          currentValueType: 'percentage',
          previousYearValue: 4.45,
          yoyChange: 32.78
        },
        {
          date: '2022-05-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          date: '2022-01-01',
          currentValue: 5.58,
          currentValueType: 'percentage',
          previousYearValue: 4.44,
          yoyChange: 25.54
        },
        {
          date: '2022-02-01',
          currentValue: 6.29,
          currentValueType: 'percentage',
          previousYearValue: 4.5,
          yoyChange: 39.71
        },
        {
          date: '2022-03-01',
          currentValue: 5.91,
          currentValueType: 'percentage',
          previousYearValue: 4.45,
          yoyChange: 32.78
        },
        {
          date: '2022-04-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        },
        {
          date: '2022-05-01',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousYearValue: 5.06,
          yoyChange: 9.36
        },
        {
          date: '2022-06-01',
          currentValue: 9.69,
          currentValueType: 'percentage',
          previousYearValue: 4.78,
          yoyChange: 102.74
        }
      ]
    }
  ]
];

export const demoSelectedGrid = [
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 9.69,
          currentValueType: 'percentage',
          previousPeriodChangeValue: 4.15,
          previousPeriodChangePercentage: 75.07,
          lastYearChangeValue: 4.91,
          lastYearChangePercentage: 102.74,
          dataStatus: null
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 5.53,
          currentValueType: 'percentage',
          previousPeriodChangeValue: -0.37,
          previousPeriodChangePercentage: -6.34,
          lastYearChangeValue: 0.47,
          lastYearChangePercentage: 9.36,
          dataStatus: null
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 5.9,
          currentValueType: 'percentage',
          previousPeriodChangeValue: -1.35,
          previousPeriodChangePercentage: -18.65,
          lastYearChangeValue: 1.23,
          lastYearChangePercentage: 26.22,
          dataStatus: null
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 6.6,
          currentValueType: 'percentage',
          previousPeriodChangeValue: 0.66,
          previousPeriodChangePercentage: 11.14,
          lastYearChangeValue: 1.65,
          lastYearChangePercentage: 33.29,
          dataStatus: null
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 6.3,
          currentValueType: 'percentage',
          previousPeriodChangeValue: 1.66,
          previousPeriodChangePercentage: 35.91,
          lastYearChangeValue: 1.66,
          lastYearChangePercentage: 35.91,
          dataStatus: null
        }
      ]
    }
  ],
  [
    {
      title: 'Spend As % of Gross <br/> Revenue',
      index: 0,
      data: [
        {
          dimension: 'Americas',
          currentValue: 6.01,
          currentValueType: 'percentage',
          previousPeriodChangeValue: -0.9,
          previousPeriodChangePercentage: -12.99,
          lastYearChangeValue: 1.37,
          lastYearChangePercentage: 29.55,
          dataStatus: null
        }
      ]
    }
  ]
];

export const demoScratchpadSlicer: Array<MultiMetricData[] | null> = [
  [
    {
      dimension: 'careable',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Careable',
      color: '#F58231',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'Carelux',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Healthgenics',
      color: '#4363D8',
      valuesWithDates: [
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'goodsable',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Goodsable',
      color: '#3CB44B',
      valuesWithDates: [
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'healthgenics',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Healthgenics',
      color: '#E6194B',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'productado',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Productado',
      color: '#FFE119',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    }
  ],
  [
    {
      dimension: 'carewood',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Carewood',
      color: '#F58231',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 4.9,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 5.17,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 4.89,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'catcareera',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Catcareera',
      color: '#4363D8',
      valuesWithDates: [
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'gastric',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Gastric',
      color: '#E6194B',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'healthify',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Healthify',
      color: '#F032E6',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 0,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'herbalProducts',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Herbal Products',
      color: '#FFE119',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 12.85,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 10.94,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 11.98,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'notYetCategorized',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Not Yet Categorized',
      color: '#3CB44B',
      valuesWithDates: [
        {
          date: '2022-05-01',
          value: 0,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'productivia',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Productivia',
      color: '#46F0F1',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 5.62,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 4.44,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 4.48,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    },
    {
      dimension: 'others',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Others',
      color: '#911EB4',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 4.1,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 2.63,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 4.25,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    }
  ],
  [
    {
      dimension: 'unitedStates',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'United States',
      color: '#E6194B',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 7.84,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 7.7,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 8.46,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    }
  ],
  [
    {
      dimension: 'americas',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Americas',
      color: '#E6194B',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 7.84,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 7.7,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 8.46,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    }
  ],
  [
    {
      dimension: 'amazon',
      currencyCode: null,
      currentValueType: 'percentage',
      label: 'Amazon',
      color: '#E6194B',
      valuesWithDates: [
        {
          date: '2022-03-01',
          value: 7.84,
          percentage: null
        },
        {
          date: '2022-04-01',
          value: 7.7,
          percentage: null
        },
        {
          date: '2022-05-01',
          value: 8.46,
          percentage: null
        }
      ],
      visible: true,
      graphVisible: true
    }
  ]
];

// export default demoSelectedGraph;
